import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { environment } from '../../../environments/environment';
import { toDateTime } from './common-conversion';

@Pipe({
    name: 'dateFromNow',
    standalone: false
})
export class DateFromNowPipe implements PipeTransform {
  transform(value: string | Date | DateTime | undefined): string {
    const locale = environment.locale;
    const date = toDateTime(value);

    if (date === null) {
      return '';
    }

    const formatted = date.setLocale(locale).toRelative();
    return formatted || '';
  }
}
